<template>
<div class="quizier-module module-flipcard">
    <div class="row">
        <div class="col-md-12">
            <div class="flipcard-holder" :class="flip_orientation">
                <div class="flipcard" :class="[{ flip: is_flipped, 'has_flipped':has_flipped }, flip_angle]">
                    <div class="front" :style="{'background-color': front_bg}" @click="flip_card(true)">
                        <div class="flip_preview preview">
                            <div class="preview" v-if="front_preview" :data-bg-color="front_bg" :style="{ backgroundImage: `url('${front_preview}')` }"></div>
                            <div v-if="front_type == 'bg'">
                                <div class="preview-bg-color" v-if="front_preview" :style="{ 'background-color': front_bg }"></div>
                                <div v-if="front_text" class="flip-text">
                                    <div class="text" :class="[front_align, front_text_class]">{{ front_text }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="flip-button-cont" v-if="!has_flipped && !is_flipped">
                            <div class="flip-button">
                                <span v-html="svg('click')"></span>
                                <div>{{ flip_message }}</div>
                            </div>
                        </div>
                    </transition>
                    <div class="back" :style="{'background-color': back_bg}" @click="flip_card(false)">
                        <div class="flip_preview preview">
                            <div class="preview" v-if="back_preview" :data-bg-color="back_bg" :style="{ backgroundImage: `url('${back_preview}')` }"></div>
                            <div v-if="back_type == 'bg'">
                                <div class="preview-bg-color" v-if="back_preview" :style="{ 'background-color': back_bg }"></div>
                                <div v-if="back_text" class="flip-text">
                                    <div class="text" :class="[back_align, back_text_class]">{{ back_text }}</div>
                                </div>
                            </div>
                            <div class="result-btn-container cta-button-flipcard" v-if="has_cta && cta_type === 'button'">
                                <button-module :block_id="me.index" :post_id="postID" :button="cta_button" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mixinComponent from '../mixins';
import {isMobile} from 'mobile-device-detect';
import buttonModule from "../libs/ctaButtonModule.vue";

export default {
    props: [],
    mixins: [mixinComponent],
    data() {
        return {
            is_flipped: false,
            has_flipped: false,
            colors: 'rgba(228,231,234,1)'
        }
    },
    components: {
        buttonModule
    },
    computed: {
        front_preview: function () {
            return this.has('front.media_path', false);
        },
        front_type: function () {
            return this.has('front.type', false);
        },
        front_text: function () {
            return this.has('front.text', '');
        },
        front_bg: function () {
            return this.rgbaToString('front.bg_color.rgba', this.colors);
        },
        front_align: function () {
            return this.has('front.text_align', 'center');
        },
        front_text_class: function () {
            return this.has('front.text_class', 'light');
        },
        back_preview: function () {
            return this.has('back.media_path', false);
        },
        back_type: function () {
            return this.has('back.type', false);
        },
        back_text: function () {
            return this.has('back.text', '');
        },
        back_bg: function () {
            return this.rgbaToString('back.bg_color.rgba', this.colors);
        },
        back_align: function () {
            return this.has('back.text_align', 'center');
        },
        back_text_class: function () {
            return this.has('back.text_class', 'light');
        },
        flip_angle: function () {
            return this.has('flip_angle', 'horizontal');
        },
        flip_orientation: function () {
            return this.has('orientation', 'landscape');
        },
        flip_message: function () {
            return isMobile ? this.$t('i18n.tap_to_flip') : this.$t('i18n.click_to_flip')
        },
        has_cta: function() {
            return this.has('back.has_cta', false)
        },
        cta_type: function() {
            return this.has('back.cta_type', false)
        },
        cta_button: function() {
            return this.has('back.button', {});
        },
    },
    methods: {
        flip_card: function (card) {
            this.is_flipped = card;
            this.has_flipped = true;
        }
    }
}
</script>
